import React from "react";
import DeviceHistoricalTrends from "./DeviceHistoricalTrends";
import DeviceRealtimeTrends from "./DeviceRealtimeTrends";
import { useSearchParams } from "react-router-dom";
import { useVsiAppContext } from "../../../../stores/VsiApp";

export default function DeviceTrends(props) {
  const { user } = useVsiAppContext();
  const [searchParams] = useSearchParams();

  const isShowRealtime = searchParams.get("data_time") === "interval" && user.role.includes('super_user');

  return isShowRealtime ? (
    <DeviceRealtimeTrends {...props}/>
  ) : (
    <DeviceHistoricalTrends {...props}/>
  );
}
